import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Table } from 'react-bootstrap';
import airbnbApi from './api';
import { ErrorAlert, PageLoader, formatTime } from './common';

const PropertyManagerList = () => {
  const [managers, setManagers] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    airbnbApi.listPropertyManagers().then(setManagers).catch(setError);
  }, []);

  return (
    // <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15">
    //     <div className="row">
    //       <div className="col-xs">
    //         <div className="d-full-height justify-content-center fnt18 tu text-start">MY BOOKING</div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div>
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15">
        <div className="d-flex justify-content-between align-items-center margbot15">
          <h4 className="mb-0">Airbnb onboarding</h4>
          <div>
            <Link to="/airbnb/notifications" className="btn btn-outline-secondary btn-sm me-2">Notifications</Link>
            <Link to="/airbnb/master-data" className="btn btn-outline-secondary btn-sm me-2">Master data</Link>
            <Link to="/airbnb/property-managers/new" className="btn btn-primary btn-sm">New property manager</Link>
          </div>
        </div>
      </div>
      <div className="container_fluid pad_lft_rht25 pad_top_bot15">
         <div className="d-flex justify-content-between align-items-center margbot15">
            <h4 className="mb-0">Property Manager</h4>
             <p className="text-muted fnt13 align-item-left">
                Takes over existing Airbnb listings through NextPax (Flow A). Create the property manager, add its
                properties, then run each step in order.
              </p>
         </div>
       
        <div className="table-responsive">
          <ErrorAlert error={error} />
          {!managers && !error && <PageLoader />}
          {managers && managers.length === 0 && <div className="pad20 tc text-muted">No property managers yet.</div>}
          {managers && managers.length > 0 && (
            <Table bordered hover size="sm" className="bg1 mt-3">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Email</th>
                  <th>Country</th>
                  <th>Currency</th>
                  <th>NextPax code</th>
                  <th>Airbnb host ID</th>
                  <th>Host connected</th>
                  <th>Properties</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {managers.map(pm => (
                  <tr key={pm.id}>
                    <td><Link to={`/airbnb/property-managers/${pm.id}`}>{pm.company_name}</Link></td>
                    <td>{pm.company_email}</td>
                    <td>{pm.country_code}</td>
                    <td>{pm.main_currency}</td>
                    <td>{pm.nextpax_code || <span className="text-muted">not created</span>}</td>
                    <td>{pm.airbnb_host_id || '—'}</td>
                    <td className="fnt12">{formatTime(pm.host_account_connected_at)}</td>
                    <td>{pm.properties_count}</td>
                    <td>
                      <Button as={Link} to={`/airbnb/property-managers/${pm.id}`} size="sm" variant="outline-primary">
                        Open
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyManagerList;
